import { Carousel, convertSecondsToTimeString, VideoCard } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'
import { InfluencerCarouselProps } from 'features/referral/components/influencer-carousel/types'
import { useGetLanguage } from 'hooks/useGetLanguage'

const InfluencerCarousel = ({ testimonials, withDescription }: InfluencerCarouselProps) => {
  // i18n
  const { t } = useTranslation('referral')
  const language = useGetLanguage('uppercase')

  return (
    <Carousel
      id="testimonials"
      language={language}
      title={t('carousel.title')}
      description={withDescription ? t('carousel.description') : undefined}
    >
      {[...testimonials]
        .sort((a, b) => b.id - a.id)
        .map((testimonial) => (
          <VideoCard
            key={testimonial.documentId}
            publicId={testimonial.video.provider_metadata.public_id}
            alt={testimonial.name}
            thumbnailPublicId={testimonial.thumbnail.provider_metadata.public_id}
            thumbnailMode="portrait"
            videoMode="reel"
            footer={{
              title: testimonial.name,
              description: convertSecondsToTimeString(testimonial.duration)
            }}
          />
        ))}
    </Carousel>
  )
}

export default InfluencerCarousel
